import { render } from "./Sortable.vue?vue&type=template&id=66c353d4"
import script from "./Sortable.vue?vue&type=script&lang=js"
export * from "./Sortable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__